<template>
    <div>
        <v-card class="pa-2">
            <canvas id="chart5" ref="chart5" height="508"></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';
import moment from 'moment';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            labels: [],
            amount: [],
            volume: [],
            title: "Val Title"
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array,
        rangeLabel: String,
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            if(this.chart && this.canvas) {
                this.chart.destroy();
                this.canvas = null;
            }
            
            this.title = 'Transaction Value Comparison By ' + this.rangeLabel;
            this.labels = this.chartData.map(e => e.currentLabels);
            this.pastLabels = this.chartData.map(e => e.pastLabels);
            this.amountCurr = this.chartData.map(e => e.currentData);
            this.amountPast = this.chartData.map(e => e.pastData);

            this.canvas = this.$refs['chart5'].getContext('2d');
            let chartData = { datasets: [] };
            chartData.datasets.push({ label: 'Current',
                                      data: this.amountCurr,
                                      borderColor: 'rgb(33,150,243, 1)',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(0, 0, 0, 0)",
                                      pointBackgroundColor: "rgb(33,150,243, 1)",
                                      pointHoverBackgroundColor: "rgb(33,150,243, 1)",
                                      pointRadius: 2,
                                      pointHoverRadius: 4 });

            chartData.datasets.push({ label: 'Past',
                                      data: this.amountPast,
                                      borderColor: 'rgb(33,150,243, 0.3)',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(0, 0, 0, 0)",
                                      pointBackgroundColor: "rgb(33,150,243, 0.3)",
                                      pointHoverBackgroundColor: "rgb(33,150,243, 0.3)",
                                      pointRadius: 2,
                                      pointHoverRadius: 4 });

            this.chart = new Chart(this.canvas, {
                type: 'line',
                data: {
                    labels: this.labels,
                    pastLabels: this.pastLabels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: this.title,
                        fontSize: 12,
                        fontStyle: 400,
                        // fontColor: '#000'
                    },
                    scales: {
                        yAxes: [{
                            positions: 'left',
                            ticks: {
                                id: 1,
                                minTicksLimit: 10,
                                beginAtZero: true,
                                fontSize: 10,
                                // fontColor: '#000',
                                callback: function(value) {
                                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'AED', minimumFractionDigits: 0 }).format(value);
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Value',
                                fontSize: 12,
                                // fontColor: '#000'
                            },
                            gridLines: {
                                // zeroLineColor: "rgb(0, 0, 0, 0.2)",
                                // color: "rgb(0, 0, 0, 0.2)"
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                // fontColor: '#000'
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Day',
                                fontSize: 12,
                                // fontColor: '#000'
                            },
                            gridLines: {
                                // zeroLineColor: "rgb(0, 0, 0, 0.2)",
                                // color: "rgb(0, 0, 0, 0.2)"
                            }
                        }]
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 10,
                            fontColor: '#000',
                            usePointStyle: true
                        },
                        position: 'top'
                    },
                    tooltips: {
                        mode: 'label',
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return '';
                            },
                            label: function(tooltipItem, data) {
                                let label = '';

                                if(data.datasets[tooltipItem.datasetIndex].label == 'Past') {
                                    label += data.pastLabels[tooltipItem.index] + ': AED ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                }
                                else if(data.datasets[tooltipItem.datasetIndex].label == 'Current') {
                                    label += data.labels[tooltipItem.index] + ': AED ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                }

                                return label;
                            }
                        }
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>